import React from 'react';

export const IntlProviderContext = React.createContext<any>({} as any);
